import React, { memo } from "react"
import threeline from "../../../asset/threeline.png"

/**
 * Props for the HamburgerButton component.
 */
interface HamburgerButtonProps {
  /**
   * Function to execute when the button is clicked.
   */
  onClick: () => void

  /**
   * Boolean flag indicating whether the menu is open.
   */
  isOpen: boolean

  /**
   * Unique identifier for the button element.
   */
  id: string
}

/**
 * HamburgerButton component renders a button with an image icon to toggle a menu.
 * It supports click handling and dynamically updates the aria-label based on the menu state.
 *
 * @param {HamburgerButtonProps} props - The properties for the HamburgerButton component.
 * @returns {JSX.Element} The rendered hamburger menu button.
 */
const HamburgerButton: React.FC<HamburgerButtonProps> = memo(
  ({ onClick, isOpen, id }) => (
    <button
      data-automation-id={id}
      id={id}
      onClick={onClick}
      className="md:hidden mr-2"
      aria-label={isOpen ? "Close menu" : "Open menu"}
    >
      <img
        src={threeline}
        alt={isOpen ? "Close Sidebar" : "Open Sidebar"}
        className="w-6 h-6"
      />
    </button>
  )
)

export default HamburgerButton